/**
 * Resolver de rutas de datos versionadas por contenido.
 *
 * La carga semanal (rama rankings-espana-advance) hashea los JSON-hoja de datos
 * y los mueve a `/d/<base>.<hash>.json` (servidos como `immutable`), y publica
 * `/data_manifest.json` con el mapa `nombre lógico → ruta hasheada`. El deploy
 * de podios sincroniza ese manifest + los `/d/…` que necesita el cruce
 * (agg_pbsb_*, RK*_200_*), y en dev el proxy de Vite los sirve desde el CDN.
 *
 * `resolveDataUrl('/agg_pbsb_A.json')` devuelve la ruta hasheada si está en el
 * manifest; si no (fichero no hasheado como los `alltime_*.json`, o deploy sin
 * hashing), devuelve la ruta lógica tal cual. Así el cliente funciona en ambos
 * casos: con hashing gana cache immutable, sin él se sirve por el nombre viejo.
 *
 * El manifest se descarga UNA vez por sesión (`no-store`, es el único puntero
 * que debe estar siempre fresco) y se memoiza. Copia del resolver de la web
 * principal (src/lib/dataManifest.ts en rankings-espana-advance) para mantener
 * paridad.
 */

type Manifest = Record<string, string>;

let manifestPromise: Promise<Manifest> | null = null;

function loadManifest(): Promise<Manifest> {
  if (!manifestPromise) {
    manifestPromise = fetch('/data_manifest.json', { cache: 'no-store' })
      .then((r) => (r.ok ? (r.json() as Promise<Manifest>) : {}))
      .catch(() => ({}));
  }
  return manifestPromise;
}

/** Resuelve una ruta lógica de dato (con '/' inicial) a su versión hasheada
 *  immutable si existe; si no, devuelve la ruta lógica sin cambios. */
export async function resolveDataUrl(logicalPath: string): Promise<string> {
  const m = await loadManifest();
  return m[logicalPath] ?? logicalPath;
}
